const inputInterception = {
  spaceScreen: function(value) {
    return value.replace(/\s+/g, '')
  }
}
export default inputInterception
